<template>
    <svg
        id="Layer_2"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 442.07 210.51">
        <defs>
            <clipPath id="clippath">
                <rect
                    x="17.86"
                    y="77.91"
                    width="116.43"
                    height="117.55"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-1">
                <rect
                    x="307.84"
                    y="82.91"
                    width="116.43"
                    height="117.55"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
        </defs>
        <g id="Layer_2-2">
            <rect
                id="Rectangle_329"
                x="285.42"
                y="56.48"
                width="156.07"
                height="21.3"
                fill="#f47941"
                stroke-width="0" />
            <path
                id="Path_2338"
                d="m338.28,61.72c-2.09,0-3.79,1.7-3.79,3.79s2.86,5.06,3.88,6.72c1.01-1.67,3.7-4.59,3.7-6.72s-1.7-3.78-3.79-3.79m0,5.42c-.96,0-1.73-.78-1.73-1.74s.78-1.73,1.74-1.73,1.73.78,1.73,1.74h0c0,.96-.78,1.73-1.74,1.73"
                fill="#fff"
                stroke-width="0" />
            <text
                transform="translate(346.24 70.93)"
                fill="#fafbfb"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="10"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    You are here
                </tspan>
            </text>
            <path
                id="Path_2278"
                d="m138.16,21.11c9.5,0,17.19,7.7,17.2,17.2v152.93c0,9.5-7.7,17.19-17.2,17.2H18.88c-9.5,0-17.19-7.7-17.2-17.2V38.31c0-9.5,7.7-17.19,17.2-17.2h119.28Zm0-1.65H18.88C8.47,19.46.03,27.9.03,38.31v152.94c0,10.41,8.44,18.85,18.85,18.85h119.27c10.41,0,18.85-8.44,18.85-18.85V38.31c0-10.41-8.44-18.85-18.85-18.85"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2279"
                d="m155.6,56.49v-15.4c.56-13.68-8.91-20.46-21.35-21.54H21.35C9.51,19.6-.05,29.24,0,41.09v15.4s155.6,0,155.6,0Z"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2250"
                d="m423.22,21.52c9.5,0,17.19,7.7,17.2,17.2v152.93c-.01,9.49-7.7,17.19-17.2,17.2h-119.27c-9.49,0-17.19-7.71-17.2-17.2V38.72c0-9.5,7.7-17.19,17.2-17.2h119.27Zm0-1.65h-119.27c-10.41,0-18.85,8.44-18.85,18.85v152.94c0,10.41,8.44,18.85,18.85,18.85h119.27c10.41,0,18.85-8.44,18.85-18.85V38.72c0-10.41-8.44-18.85-18.85-18.85"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2251"
                d="m441.59,57.3v-15.34c.09-13.33-9.52-22.76-21.44-21.46h-113.38c-5.31-.08-10.48,1.7-14.63,5.02-4.56,3.93-6.82,9.95-6.82,16.44v15.34h156.27Z"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2252"
                d="m353.24,22.65v7.7h7.19l-.51-7.18s-6.68-.52-6.68-.52Z"
                fill="#cfd5ea"
                stroke-width="0" />
            <path
                id="Path_2257"
                d="m369.1,17.87c.28,0,.51.23.51.51v8.53c0,.28-.23.51-.51.51h-8.49c-.28,0-.51-.23-.51-.51s.23-.51.51-.51h7.98v-8.02c0-.28.23-.51.51-.51"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2258"
                d="m360.42,30.35h-7.19c-.28,0-.51-.23-.51-.51h0v-7.19c0-.28.23-.51.51-.51h7.19c.28,0,.51.23.51.51v7.19c0,.28-.23.51-.51.51m-6.68-1.02h6.16v-6.16h-6.16v6.16Z"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_1485"
                d="m363.09,1.39c9.41,0,17.03,7.63,17.03,17.03s-7.63,17.03-17.03,17.03-17.03-7.63-17.03-17.03h0c0-9.41,7.63-17.03,17.03-17.03"
                fill="#fff"
                stroke="#405184" />
            <rect
                id="Rectangle_308"
                x="365.56"
                y="8.8"
                width="7.19"
                height="7.19"
                fill="#95b1e8"
                stroke-width="0" />
            <rect
                id="Rectangle_309"
                x="352.92"
                y="20.67"
                width="7.19"
                height="7.19"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1487"
                d="m372.74,16.5h-7.19c-.28,0-.51-.23-.51-.51v-7.19c0-.28.23-.51.51-.51h7.19c.28,0,.51.23.51.51v7.19c0,.28-.23.51-.51.51m-6.68-1.02h6.17v-6.16h-6.17v6.16Z"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1488"
                d="m357.02,21.44c-.28,0-.51-.23-.51-.51v-8.53c0-.28.23-.51.51-.51h8.49c.28,0,.51.23.51.51s-.23.51-.51.51h-7.98v8.02c0,.28-.23.51-.51.51"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1489"
                d="m369.29,16.15c.28,0,.51.23.51.51v8.53c0,.28-.23.51-.51.51h-8.49c-.28,0-.51-.23-.51-.51s.23-.51.51-.51h7.98v-8.02c0-.28.23-.51.51-.51"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1490"
                d="m360.62,28.63h-7.19c-.28,0-.51-.23-.51-.51v-7.19c0-.28.23-.51.51-.51h7.19c.28,0,.51.23.51.51v7.19c0,.28-.23.51-.51.51m-6.67-1.02h6.16v-6.16h-6.16v6.16Z"
                fill="#405184"
                stroke-width="0" />
            <rect
                id="Rectangle_310"
                x="345.23"
                y=".57"
                width="35.71"
                height="35.71"
                fill="none"
                stroke-width="0" />
            <path
                id="Path_1563"
                d="m75.81,20.86c-.25-.26-.67-.27-.93-.01h0l-6.58,6.54c-.27.25-.28.66-.03.93.13.14.31.22.5.21.18,0,.35-.07.47-.2l6.58-6.52c.26-.25.27-.67.01-.93h-.01"
                fill="#5c73b8"
                stroke-width="0" />
            <g id="Group_715">
                <path
                    id="Path_2499"
                    d="m79.82.5c9.43,0,17.08,7.65,17.08,17.08s-7.65,17.08-17.08,17.08-17.08-7.65-17.08-17.08h0c0-9.43,7.64-17.08,17.08-17.08h0"
                    fill="#fff"
                    stroke="#405184"
                    stroke-miterlimit="10" />
                <path
                    id="Path_2512"
                    d="m77.34,23.59l-2.94,3.36c-.23.29-.18.71.1.94.27.22.66.19.9-.06l2.94-3.36c.23-.28.19-.7-.09-.94-.27-.22-.67-.2-.91.06"
                    fill="#405184"
                    stroke-width="0" />
                <path
                    id="Path_2509"
                    d="m69.89,22.65c.17,0,.34-.07.47-.19l3.22-3.11c.27-.25.28-.67.03-.94s-.67-.28-.94-.03c0,0-.01.01-.02.02l-3.22,3.11c-.27.25-.29.66-.04.93.13.14.31.22.51.21"
                    fill="#405184"
                    stroke-width="0" />
                <path
                    id="Path_2510"
                    d="m76.83,20.18c-.25-.26-.67-.27-.93-.01h0l-6.58,6.54c-.27.25-.28.66-.03.93.13.14.31.22.5.21.18,0,.35-.07.47-.2l6.58-6.52c.26-.25.27-.67.01-.93h-.01"
                    fill="#405184"
                    stroke-width="0" />
                <path
                    id="Path_2505"
                    d="m90.49,8.17v-.11s-.01-.07-.02-.1c-.01-.04-.03-.07-.05-.11,0-.02-.01-.04-.02-.06l-.03-.03s-.05-.06-.08-.08c-.03-.03-.05-.05-.08-.07l-.03-.03s-.04-.01-.06-.02c-.03-.02-.07-.03-.11-.04-.03-.01-.07-.02-.11-.02h-.11s-.07,0-.11.01c-.02,0-.05,0-.07.01l-20.07,6.73c-.35.1-.55.47-.45.82.06.21.22.37.42.44l9.48,3.63,3.78,9.43c.1.25.35.42.62.42h.02c.28,0,.53-.19.61-.46l6.41-20.17s0-.05.01-.07c0-.04.01-.07.01-.11m-3.09,1.49l-8.04,8.17-7.61-2.91s15.65-5.26,15.65-5.26Zm-4.07,16.66l-3.02-7.55,8.04-8.17s-5.02,15.72-5.02,15.72Z"
                    fill="#405184"
                    stroke-width="0" />
            </g>
            <polygon
                points="83.26 26.33 80.26 18.76 88.32 10.61 83.26 26.33"
                fill="#fff"
                stroke-width="0" />
            <polygon
                points="87.36 9.67 79.32 17.84 71.71 14.93 87.36 9.67"
                fill="#fff"
                stroke-width="0" />
            <text
                transform="translate(322.12 48.49)"
                fill="#fafbfb"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="12"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Linked Program
                </tspan>
            </text>
            <text
                transform="translate(26.79 48.49)"
                fill="#fafbfb"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="12"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Publishing Program
                </tspan>
            </text>
            <path
                id="Path_1366"
                d="m214.63,101.99c-.16,0-.3-.11-.34-.26l-4.18-15.74c-.03-.18.07-.36.25-.43l8.23-2.18,4.54,3.24,3.17,11.93c.02.09,0,.18-.04.26-.05.08-.12.14-.21.16l-11.32,3-.09.02Z"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_1367"
                d="m218.46,84.06l4.12,2.94,3.04,11.45-10.8,2.87-4.04-15.23,7.68-2.04Zm.22-1.33h-.03l-8.45,2.24c-.52.14-.82.67-.69,1.18l4.17,15.74c.11.42.5.72.93.72.08,0,.17-.01.25-.03l11.32-3c.51-.13.82-.66.69-1.18l-3.21-12.1s-.02-.05-.04-.07l-4.89-3.49s-.04-.02-.07-.02"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1368"
                d="m222.88,102.12l-11.36-2.88c-.19-.05-.3-.24-.25-.42l4-15.79c.04-.16.18-.27.34-.27l8.34,2.1,2.39,5.03-3.03,11.97c-.04.15-.18.26-.33.26-.03,0-.06,0-.09-.01"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_1369"
                d="m215.8,83.45l7.7,1.95,2.18,4.57-2.9,11.49-10.83-2.74,3.86-15.27Zm-.2-1.3c-.44,0-.83.3-.94.73l-4,15.79c-.13.52.18,1.04.7,1.17,0,0,0,0,0,0l11.36,2.88c.08.02.16.03.24.03.44,0,.82-.3.93-.72l3.07-12.14s0-.05,0-.08l-2.58-5.42s-.05-.05-.08-.06l-8.47-2.14c-.08-.02-.16-.03-.24-.03"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1370"
                d="m224.42,88.7c-.17-.05-.31-.17-.39-.33-.1-.21-.13-.45-.07-.67l.46-1.82,1.52,3.2-1.53-.38Z"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_1371"
                d="m224.6,87.7l.22.47-.23-.06c-.05-.08-.06-.17-.03-.26l.04-.15Zm-.33-3.4h0s-.09.04-.1.09l-.8,3.16c-.23.73.17,1.51.9,1.75l2.56.65h.02s.07-.02.1-.04c.03-.03.04-.08.01-.12l-2.58-5.42s-.06-.06-.11-.06"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1372"
                d="m220.64,97.19c0,4.53-3.67,8.2-8.2,8.2s-8.2-3.67-8.2-8.2,3.67-8.2,8.2-8.2h0c4.53,0,8.2,3.67,8.2,8.2"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_1373"
                d="m210.44,92.6c-.19.09-.38.21-.55.34-.14.11-.35.08-.46-.06-.11-.14-.09-.34.04-.45,0,0,0,0,.01-.01.21-.16.43-.3.67-.42.17-.08.36-.01.44.16.08.17.01.36-.16.44"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_1374"
                d="m210.3,91.97s-.1.01-.14.03c-.24.11-.46.25-.67.42-.14.11-.17.31-.07.45,0,0,0,0,0,.01.11.14.32.17.46.06.17-.13.36-.25.55-.34.16-.08.23-.28.15-.44-.06-.11-.17-.19-.3-.19"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1375"
                d="m214.18,93.48c-.6-.77-1.54-1.21-2.53-1.18-.18,0-.34-.14-.35-.32,0-.18.14-.34.32-.34,1.19-.04,2.34.49,3.07,1.43.11.14.09.34-.04.45,0,0,0,0-.01.01-.15.11-.35.08-.46-.06"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_1376"
                d="m211.76,91.64h-.14c-.18,0-.33.16-.32.34s.16.33.34.32h.13c.94,0,1.83.44,2.41,1.18.06.08.16.12.26.12.07,0,.14-.03.2-.07.14-.11.17-.31.07-.45,0,0,0-.01-.01-.01-.7-.9-1.79-1.43-2.93-1.43"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1377"
                d="m220.47,106.53c.74-.57.88-1.64.31-2.38,0,0,0-.01-.01-.02l-4.5-5.79c1.66-2.49.99-5.86-1.5-7.53-2.49-1.66-5.86-.99-7.53,1.5-1.66,2.49-.99,5.86,1.5,7.53,1.42.95,3.21,1.17,4.83.6l4.5,5.79c.57.74,1.64.88,2.38.31,0,0,.01,0,.02-.01m-3.99-10.59c-.32,2.6-2.69,4.45-5.29,4.12-2.6-.32-4.45-2.69-4.12-5.29.32-2.6,2.69-4.45,5.29-4.12,0,0,0,0,0,0,2.6.33,4.44,2.69,4.12,5.29m3.58,10.07c-.46.34-1.11.26-1.47-.18l-4.39-5.64c.63-.32,1.19-.75,1.66-1.29l4.39,5.64c.34.46.26,1.11-.18,1.47"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_1378"
                d="m211.77,89.95c-2.99,0-5.4,2.43-5.4,5.41,0,2.72,2.03,5.02,4.73,5.36.22.03.44.04.66.04.62,0,1.23-.11,1.81-.31l4.5,5.79c.31.41.79.66,1.31.67.39,0,.77-.13,1.09-.37.74-.57.88-1.64.31-2.38,0,0,0-.01-.01-.02l-4.5-5.79c1.66-2.48,1-5.83-1.48-7.48-.7-.47-1.51-.77-2.35-.87-.22-.03-.45-.04-.67-.04m0,10.15c-2.62,0-4.75-2.12-4.75-4.74s2.12-4.75,4.74-4.75c2.62,0,4.75,2.12,4.75,4.74,0,.2-.01.4-.04.59-.31,2.37-2.31,4.14-4.7,4.16m7.65,6.12c-.32,0-.63-.14-.84-.39l-4.39-5.64c.63-.32,1.19-.75,1.65-1.29l4.39,5.64c.34.46.26,1.11-.18,1.47-.18.14-.41.21-.63.21"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1379"
                d="m221.99,91.23l-.21,1.47h1.03v.56h-1.12l-.29,2.09h-.67l.3-2.09h-1.52l-.29,2.09h-.67l.29-2.09h-.99v-.56h1.06l.21-1.47h-1.03v-.57h1.11l.29-2.06h.67l-.3,2.06h1.52l.29-2.06h.66l-.3,2.06h.99v.57h-1.06Zm-2.18,0l-.21,1.47h1.52l.21-1.47h-1.52Z"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1395"
                d="m138.45,86.81l-8.74,8.62h0s-.06.06-.09.1l-.04.04c-.21.25-.35.54-.41.86h0c-.01.06-.02.12-.03.19s-.01.13-.01.19c0,.07,0,.13.01.19,0,.06.02.12.03.19h0c.06.32.2.61.41.86.01.02.03.03.04.04.03.03.06.07.09.1h0l8.74,8.62c.77.76,2.01.75,2.76-.02s.75-2.01-.02-2.76h0l-5.35-5.28h14.35c1.08,0,1.96-.88,1.96-1.96s-.88-1.96-1.96-1.96h-14.35l5.35-5.28c.79-.74.82-1.98.08-2.76-.74-.79-1.98-.82-2.76-.08-.02.02-.05.04-.07.07"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1396"
                d="m164.14,96.38c0,1.08-.88,1.95-1.96,1.96h-2.81c-1.08,0-1.96-.88-1.96-1.96s.88-1.96,1.96-1.96h2.81c1.08,0,1.95.88,1.96,1.96"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1397"
                d="m173.16,96.35v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1398"
                d="m182.64,96.35v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1399"
                d="m192.54,96.35v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1400"
                d="m254.94,96.35v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1401"
                d="m244.86,96.35v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1419"
                d="m290.74,96.38c0-1.08.88-1.95,1.96-1.96h2.81c1.08,0,1.96.88,1.96,1.96s-.88,1.96-1.96,1.96h-2.81c-1.08,0-1.95-.88-1.96-1.96"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1420"
                d="m282.03,96.41v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1421"
                d="m271.74,96.41v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1422"
                d="m261.19,96.41v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1441"
                d="m216.88,95.36c0,2.91-2.36,5.26-5.26,5.26-2.91,0-5.26-2.36-5.26-5.26,0-2.9,2.36-5.26,5.26-5.26,2.91,0,5.26,2.36,5.26,5.26Z"
                fill="none"
                stroke="#555"
                stroke-miterlimit="10"
                stroke-width=".75" />
            <path
                id="Path_1442"
                d="m213.75,100.68l4.46,5.7s3.15.94,2.56-2.25l-4.34-5.58"
                fill="none"
                stroke="#555"
                stroke-miterlimit="10"
                stroke-width=".75" />
            <text
                transform="translate(195.28 115.53)"
                fill="#555"
                font-family="SourceSansPro-SemiBold, 'Source Sans Pro'"
                font-size="8"
                font-weight="600"
                letter-spacing="-.01em">
                <tspan
                    x="0"
                    y="0">
                    Finds Project
                </tspan>
                <tspan
                    x="-10.54"
                    y="9.6">
                    Via Project Number
                </tspan>
            </text>
            <g
                id="Group_456"
                opacity=".56">
                <g id="Group_455">
                    <g clip-path="url(#clippath)">
                        <g id="Group_454">
                            <path
                                id="Path_1195"
                                d="m131.42,161.58l-59.11,33.17c-2.7,1.51-6.11.55-7.62-2.14L18.57,110.43c-1.51-2.7-.55-6.1,2.14-7.62l44.09-24.74c.18-.09.38-.11.57-.07l32.42,12.48c.14.07.26.18.33.32l35.46,63.19c1.5,2.68.54,6.07-2.15,7.57,0,0-.01,0-.02,0"
                                fill="#ced5ea"
                                stroke-width="0" />
                            <path
                                id="Path_1196"
                                d="m116.49,184.21l-67.78.28c-3.09,0-5.6-2.48-5.62-5.57l-.39-94.23c0-3.09,2.48-5.6,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.65c.09.13.14.28.13.44l.3,72.46c0,3.08-2.48,5.57-5.56,5.58,0,0-.01,0-.02,0"
                                fill="#eff1fb"
                                stroke-width="0" />
                            <path
                                id="Path_1197"
                                d="m116.49,184.21l-67.78.28c-3.09,0-5.6-2.48-5.62-5.57l-.39-94.23c0-3.09,2.48-5.6,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.65c.09.13.14.28.13.44l.3,72.46c0,3.08-2.48,5.57-5.56,5.58,0,0-.01,0-.02,0Z"
                                fill="none"
                                stroke="#ced5ea"
                                stroke-miterlimit="10" />
                            <path
                                id="Path_1198"
                                d="m121.05,106.71l-15.29.06c-4.14.02-7.55-3.8-7.57-8.52l-.08-18.86c0-.28.18-.52.44-.62.26-.08.55-.02.75.17l22.28,26.66c.18.19.22.47.09.7-.13.22-.36.37-.61.4"
                                fill="#eff1fb"
                                stroke-width="0" />
                            <path
                                id="Path_1199"
                                d="m121.05,106.71l-15.29.06c-4.14.02-7.55-3.8-7.57-8.52l-.08-18.86c0-.28.18-.52.44-.62.26-.08.55-.02.75.17l22.28,26.66c.18.19.22.47.09.7-.13.23-.36.38-.62.4Z"
                                fill="none"
                                stroke="#ced5ea"
                                stroke-miterlimit="10" />
                        </g>
                    </g>
                </g>
            </g>
            <path
                id="Path_1328"
                d="m76.86,148.12c-.08-.02-.15-.05-.22-.08.07.03.14.06.21.09h.03s-.02,0-.02,0"
                fill="#eff1fb"
                stroke-width="0" />
            <g
                id="Group_465"
                opacity=".56">
                <g id="Group_464">
                    <g clip-path="url(#clippath-1)">
                        <g id="Group_463">
                            <path
                                id="Path_1245"
                                d="m421.41,166.57l-59.12,33.17c-2.7,1.51-6.11.55-7.62-2.14l-46.11-82.17c-1.51-2.7-.55-6.1,2.14-7.62l44.09-24.74c.18-.09.38-.11.57-.07l32.42,12.48c.14.07.26.18.33.32l35.46,63.19c1.5,2.68.54,6.07-2.15,7.57,0,0-.01,0-.02,0"
                                fill="#ced5ea"
                                stroke-width="0" />
                            <path
                                id="Path_1246"
                                d="m406.48,189.2l-67.78.28c-3.09,0-5.6-2.48-5.62-5.57l-.39-94.23c0-3.09,2.48-5.6,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.66c.09.13.14.28.13.44l.3,72.46c0,3.08-2.49,5.57-5.56,5.58h-.01"
                                fill="#eff1fb"
                                stroke-width="0" />
                            <path
                                id="Path_1247"
                                d="m406.48,189.2l-67.78.28c-3.09,0-5.6-2.48-5.62-5.57l-.39-94.23c0-3.09,2.48-5.6,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.66c.09.13.14.28.13.44l.3,72.46c0,3.08-2.49,5.57-5.56,5.57h-.01Z"
                                fill="none"
                                stroke="#ced5ea"
                                stroke-miterlimit="10" />
                            <path
                                id="Path_1248"
                                d="m411.03,111.71l-15.29.06c-4.14.02-7.55-3.8-7.57-8.52l-.08-18.87c0-.28.18-.52.44-.62.26-.08.55-.02.75.17l22.28,26.67c.18.19.22.47.09.7-.13.22-.36.37-.61.4"
                                fill="#eff1fb"
                                stroke-width="0" />
                            <path
                                id="Path_1249"
                                d="m411.03,111.71l-15.29.06c-4.14.02-7.55-3.8-7.57-8.52l-.08-18.87c0-.28.18-.52.44-.62.26-.08.55-.02.75.17l22.28,26.67c.18.19.22.47.09.7-.13.23-.36.38-.61.4Z"
                                fill="none"
                                stroke="#ced5ea"
                                stroke-miterlimit="10" />
                        </g>
                    </g>
                </g>
            </g>
            <path
                id="Path_1342"
                d="m371.32,144.75c.08.02.15.05.22.08-.07-.03-.14-.06-.21-.09h-.03s.02,0,.02,0"
                fill="#eff1fb"
                stroke-width="0" />
            <path
                id="Path_1337"
                d="m78.94,147.83c.49-1.7,1.6-3.16,3.12-4.07-3.32-.09-6.08,2.53-6.17,5.84-.08,2.75,1.73,5.2,4.37,5.95.58.16,1.18.22,1.78.2-2.69-1.65-3.96-4.89-3.1-7.92"
                fill="#ced5ea"
                stroke-width="0" />
            <path
                id="Path_1339"
                d="m83.85,142.98s-.06-.03-.09-.04c-.6-.17-1.22-.24-1.84-.22.64,0,1.28.09,1.9.26h.03"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1342-2"
                d="m83.84,142.99c.08.02.15.05.22.08-.07-.03-.14-.06-.21-.09h-.03s.02,0,.02,0"
                fill="#eff1fb"
                stroke-width="0" />
            <path
                id="Path_1348"
                d="m85.57,143.76c-.47-.29-.98-.52-1.51-.69.48.17.94.4,1.37.69h.14"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1350"
                d="m83.82,142.99c-.62.17-1.21.43-1.77.76.51,0,1.02.07,1.51.21.08.02.14.06.22.09.53-.17,1.08-.27,1.64-.29-.42-.29-.88-.52-1.37-.69-.07-.02-.15-.05-.22-.07h-.02"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1338"
                d="m79.33,149.39c-.2,3.2,1.61,6.02,4.04,6.28,2.44.27,4.58-2.11,4.78-5.32s-1.61-6.02-4.04-6.28c-.31-.03-.62-.02-.93.03-1.87.82-3.31,2.8-3.85,5.29"
                fill="#ced5ea"
                stroke-width="0" />
            <path
                id="Path_1340"
                d="m87.62,142.99c-1.23-.35-2.54-.36-3.78-.01.07.02.14.06.21.09.53.17,1.04.4,1.51.69,3.31-.09,6.07,2.52,6.16,5.83s-2.52,6.07-5.83,6.16c-.12,0-.23,0-.35,0-.55.33-1.14.59-1.77.76,3.74,1.06,7.62-1.11,8.68-4.84s-1.11-7.62-4.84-8.68"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1344"
                d="m82.6,156.06c-.85.14-1.71.09-2.54-.14-3.41-1.12-5.27-4.79-4.16-8.2.73-2.78,3.15-4.78,6.02-4.99-3.88-.01-7.04,3.12-7.05,7-.01,3.88,3.12,7.04,7,7.05.65,0,1.29-.09,1.92-.26h-.02c-.4-.12-.79-.27-1.17-.46"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1346"
                d="m75.9,147.71c-1.11,3.41.75,7.08,4.16,8.2.83.23,1.69.28,2.54.14-.19-.1-.38-.2-.56-.31-3.31,0-6-2.7-5.99-6.01s2.7-6,6.01-5.99c.55-.33,1.14-.59,1.76-.76-.62-.17-1.26-.26-1.9-.26-2.87.2-5.29,2.21-6.02,4.99"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1341"
                d="m79.9,148.1c.55-1.91,2-3.42,3.88-4.05-.08-.03-.14-.07-.22-.09-.49-.13-1-.2-1.51-.21-3.32,2-4.38,6.31-2.38,9.62.58.97,1.4,1.78,2.36,2.37.61,0,1.21-.1,1.79-.29-3.07-1-4.8-4.25-3.92-7.36"
                fill="#aac5f2"
                stroke-width="0" />
            <path
                id="Path_1345"
                d="m87.92,151.14c.84-2.74-.17-5.71-2.49-7.38-.56.02-1.11.11-1.64.29,3.15,1.02,4.88,4.41,3.86,7.57-.59,1.81-2.01,3.24-3.82,3.84.08.03.14.07.22.09.05.01.09.01.14.03,1.83-.86,3.2-2.48,3.73-4.43"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1343"
                d="m87.92,151.14c-.54,1.95-1.9,3.57-3.73,4.43.45.11.91.17,1.37.18,3.32-2,4.38-6.3,2.39-9.62-.59-.97-1.4-1.79-2.37-2.37h-.15c2.33,1.67,3.33,4.64,2.49,7.38"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1349"
                d="m83.82,155.46c-.58.19-1.18.28-1.79.29.18.11.37.22.56.31.55-.09,1.08-.25,1.59-.49-.05-.01-.09-.01-.14-.03-.08-.02-.15-.06-.22-.09"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1347"
                d="m84.18,155.57c-.5.23-1.04.4-1.59.49.38.19.77.34,1.17.46h.02c.62-.17,1.21-.43,1.77-.76-.46,0-.92-.07-1.37-.18"
                fill="#95b1e8"
                stroke-width="0" />
            <text
                transform="translate(65.52 124.01)"
                fill="#405184"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="11"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Project
                </tspan>
                <tspan
                    x="-12.07"
                    y="11">
                    Predecessor
                </tspan>
            </text>
            <text
                transform="translate(354.47 125.01)"
                fill="#405184"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="11"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Project
                </tspan>
                <tspan
                    x="-6.71"
                    y="12">
                    Successor
                </tspan>
            </text>
            <path
                id="Path_1330"
                d="m373.3,143.45c.85-.14,1.71-.09,2.54.14,3.41,1.12,5.27,4.79,4.16,8.2-.73,2.78-3.15,4.78-6.02,4.99,3.88.01,7.04-3.12,7.05-7,.01-3.88-3.12-7.04-7-7.05-.65,0-1.29.09-1.92.26h.02c.4.12.79.27,1.17.46"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1323"
                d="m376.96,151.69c-.49,1.7-1.6,3.16-3.12,4.07,3.32.09,6.08-2.53,6.17-5.84.08-2.75-1.73-5.2-4.37-5.95-.58-.16-1.18-.22-1.78-.2,2.69,1.65,3.96,4.89,3.1,7.92"
                fill="#ced5ea"
                stroke-width="0" />
            <path
                id="Path_1324"
                d="m376.91,150.4c.21-3.22-1.68-6.05-4.22-6.32-2.54-.27-4.77,2.13-4.98,5.35-.21,3.22,1.68,6.05,4.22,6.32.32.03.65.03.97-.03,1.95-.83,3.45-2.82,4.02-5.32"
                fill="#ced5ea"
                stroke-width="0" />
            <path
                id="Path_1326"
                d="m368.27,156.52c1.23.35,2.54.36,3.78.01-.07-.02-.14-.06-.21-.09-.53-.17-1.04-.4-1.51-.69-3.31.09-6.07-2.52-6.16-5.83-.09-3.31,2.52-6.07,5.83-6.16.12,0,.23,0,.35,0,.55-.33,1.14-.59,1.77-.76-3.74-1.06-7.62,1.11-8.68,4.84s1.11,7.62,4.84,8.68"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1332"
                d="m380,151.8c1.11-3.41-.75-7.08-4.16-8.2-.83-.23-1.69-.28-2.54-.14.19.1.38.2.56.31.6-.02,1.2.04,1.78.2,3.2.89,5.07,4.21,4.18,7.41-.74,2.66-3.21,4.48-5.98,4.39-.55.33-1.14.59-1.76.76.62.17,1.26.26,1.9.26,2.87-.2,5.29-2.21,6.02-4.99"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1327"
                d="m375.99,151.41c-.54,1.91-1.99,3.43-3.88,4.06.08.03.14.07.22.09.49.13,1,.2,1.51.21,3.32-2,4.38-6.31,2.38-9.62-.58-.97-1.4-1.78-2.36-2.37-.61,0-1.21.1-1.79.29,3.07,1,4.8,4.25,3.92,7.36"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1331"
                d="m367.98,148.37c-.84,2.74.17,5.71,2.49,7.38.56-.02,1.11-.11,1.64-.29-3.15-1.03-4.88-4.42-3.85-7.57.59-1.81,2-3.24,3.81-3.84-.08-.03-.14-.07-.22-.09-.05-.01-.09-.01-.14-.03-1.83.86-3.2,2.48-3.73,4.43"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1329"
                d="m367.98,148.37c.54-1.95,1.9-3.57,3.73-4.43-.45-.11-.91-.17-1.37-.18-3.32,2-4.38,6.3-2.39,9.62.59.97,1.4,1.79,2.37,2.37h.15c-2.33-1.67-3.33-4.64-2.49-7.38"
                fill="#95b1e8"
                stroke-width="0" />
            <polygon
                points="372.04 144.06 373.83 143.77 373.08 143.03 371.79 142.92 370.32 143.76 372.04 144.06"
                fill="#95b1e8"
                stroke-width="0" />
            <polygon
                points="372.1 155.47 370.32 155.76 371.06 156.49 372.36 156.61 373.83 155.77 372.1 155.47"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_708"
                d="m405.36,113.21h-88.56c-3.45,0-8.28.06-10.82-2.18-2.21-1.94-2.03-6.28-2.03-9.64v-5.95c0-3.06-.27-6.99,2.03-9.32,2.12-2.15,7.05-2.5,10.82-2.5h88.56c3.89,0,8.25-.55,10.82,2.2,1.73,1.84,2.05,6.68,2.05,9.63v5.95c0,3.38.09,7.29-3.13,10.24s-6.31,1.58-9.73,1.58"
                fill="#f0f1f9"
                isolation="isolate"
                opacity=".8"
                stroke-width="0" />
            <path
                id="Rectangle_110"
                d="m311.74,83.62h98.78c4.31,0,7.81,3.21,7.81,7.17v15.26c0,3.96-3.5,7.17-7.81,7.17h-98.78c-4.31,0-7.81-3.21-7.81-7.17v-15.26c0-3.96,3.5-7.17,7.81-7.17Z"
                fill="none"
                stroke="#405184"
                stroke-miterlimit="10"
                stroke-width=".25" />
            <path
                id="Path_2284"
                d="m321.45,92.46c-.11,0-.21-.04-.29-.12-2.31-2.3-6.04-2.3-8.35,0-.16.16-.43.15-.58,0-.16-.16-.16-.41,0-.57,2.63-2.62,6.89-2.62,9.52,0,.16.16.16.42,0,.58-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2285"
                d="m313.68,93.63c-.11,0-.21-.04-.29-.12-.16-.16-.16-.42,0-.58,1.99-1.98,5.2-1.98,7.19,0,.16.16.17.42,0,.58-.16.16-.42.17-.58,0h0c-1.66-1.66-4.36-1.66-6.02,0-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2286"
                d="m319.12,94.79c-.11,0-.21-.04-.29-.12-1.03-.99-2.66-.99-3.69,0-.16.16-.43.15-.58,0-.16-.16-.16-.41,0-.57,1.36-1.3,3.5-1.3,4.86,0,.16.16.16.42,0,.58h0c-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2287"
                d="m318.29,104.74h-2.99c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h2.99c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2288"
                d="m316.8,104.6c-.18,0-.33-.15-.33-.33v-.92c0-.18.15-.33.33-.33s.33.15.33.33v.92c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2289"
                d="m316.49,99.83c-.11,0-.21-.05-.27-.14l-1.07-1.56c-.1-.15-.06-.36.09-.46s.36-.06.46.09l1.07,1.56c.1.15.07.35-.08.46h0c-.06.04-.12.06-.19.06"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2290"
                d="m318.58,100.88s-.07,0-.11-.02l-1.49-.51c-.17-.06-.26-.25-.2-.42s.24-.26.41-.2h0l1.49.51c.17.06.26.25.2.42-.05.13-.17.22-.31.22"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2291"
                d="m314.61,97.33c-.09,0-.17-.04-.23-.1l-.99-.99c-.13-.13-.13-.34,0-.47s.34-.13.47,0h0l.99.99c.13.13.13.34,0,.47-.06.06-.15.1-.23.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2292"
                d="m318.83,97.33c-.18,0-.33-.15-.33-.33,0-.09.03-.17.1-.23l1.05-1.05c.13-.13.34-.13.47,0s.13.34,0,.47l-1.05,1.05c-.06.06-.15.1-.23.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2293"
                d="m316.76,103.57c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76,3.76,1.68,3.76,3.76-1.68,3.76-3.76,3.76m0-6.86c-1.71,0-3.1,1.39-3.1,3.1s1.39,3.1,3.1,3.1,3.1-1.39,3.1-3.1h0c0-1.71-1.39-3.1-3.1-3.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2294"
                d="m316.76,100.55c-.41,0-.74-.33-.74-.74s.33-.74.74-.74.74.33.74.74-.33.74-.74.74m0-.82s-.08.04-.08.08c0,.09.16.09.16,0,0-.04-.03-.08-.08-.08h0"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2295"
                d="m316.76,103.57c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76,3.76,1.68,3.76,3.76-1.68,3.76-3.76,3.76m0-6.86c-1.71,0-3.1,1.39-3.1,3.1s1.39,3.1,3.1,3.1,3.1-1.39,3.1-3.1h0c0-1.71-1.39-3.1-3.1-3.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2296"
                d="m316.76,97.76c-.18,0-.33-.15-.33-.33v-.43c0-.18.15-.33.33-.33s.33.15.33.33v.43c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2297"
                d="m316.76,102.91c-.18,0-.33-.15-.33-.33v-.43c0-.18.15-.33.33-.33s.33.15.33.33v.43c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2298"
                d="m319.54,100.12h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2299"
                d="m314.4,100.12h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <text
                transform="translate(328.92 102.34)"
                fill="#405184"
                font-family="SourceSansPro-BoldItalic, 'Source Sans Pro'"
                font-size="8"
                font-style="italic"
                font-weight="700"
                letter-spacing="-.01em">
                <tspan
                    x="0"
                    y="0">
                    Admin Page
                </tspan>
            </text>
            <path
                id="Path_708-2"
                d="m407.39,193.18h-88.56c-3.45,0-8.28.06-10.82-2.18-2.21-1.94-2.03-6.28-2.03-9.64v-5.95c0-3.06-.27-6.99,2.03-9.32,2.12-2.15,7.05-2.5,10.82-2.5h88.56c3.89,0,8.25-.55,10.82,2.2,1.73,1.84,2.05,6.68,2.05,9.63v5.95c0,3.38.09,7.29-3.13,10.24s-6.31,1.58-9.73,1.58"
                fill="#f0f1f9"
                isolation="isolate"
                opacity=".8"
                stroke-width="0" />
            <path
                id="Rectangle_110-2"
                d="m313.77,163.59h98.78c4.31,0,7.81,3.21,7.81,7.17v15.26c0,3.96-3.5,7.17-7.81,7.17h-98.78c-4.31,0-7.81-3.21-7.81-7.17v-15.26c0-3.96,3.5-7.17,7.81-7.17Z"
                fill="none"
                stroke="#44b649"
                stroke-miterlimit="10"
                stroke-width=".75" />
            <path
                id="Path_2284-2"
                d="m323.47,172.43c-.11,0-.21-.04-.29-.12-2.31-2.3-6.04-2.3-8.35,0-.16.16-.43.15-.58,0-.16-.16-.16-.41,0-.57,2.63-2.62,6.89-2.62,9.52,0,.16.16.16.42,0,.58-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2285-2"
                d="m315.7,173.6c-.11,0-.21-.04-.29-.12-.16-.16-.16-.42,0-.58,1.99-1.98,5.2-1.98,7.19,0,.16.16.17.42,0,.58-.16.16-.42.17-.58,0h0c-1.66-1.66-4.36-1.66-6.02,0-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2286-2"
                d="m321.14,174.76c-.11,0-.21-.04-.29-.12-1.03-.99-2.66-.99-3.69,0-.16.16-.43.15-.58,0-.16-.16-.16-.41,0-.57,1.36-1.3,3.5-1.3,4.86,0,.16.16.16.42,0,.58h0c-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2287-2"
                d="m320.31,184.71h-2.99c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h2.99c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2288-2"
                d="m318.82,184.57c-.18,0-.33-.15-.33-.33v-.92c0-.18.15-.33.33-.33s.33.15.33.33v.92c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2289-2"
                d="m318.51,179.8c-.11,0-.21-.05-.27-.14l-1.07-1.56c-.1-.15-.06-.36.09-.46s.36-.06.46.09l1.07,1.56c.1.15.07.35-.08.46h0c-.06.04-.12.06-.19.06"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2290-2"
                d="m320.6,180.85s-.07,0-.11-.02l-1.49-.51c-.17-.06-.26-.25-.2-.42s.24-.26.41-.2h0l1.49.51c.17.06.26.25.2.42-.05.13-.17.22-.31.22"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2291-2"
                d="m316.63,177.3c-.09,0-.17-.04-.23-.1l-.99-.99c-.13-.13-.13-.34,0-.47s.34-.13.47,0h0l.99.99c.13.13.13.34,0,.47-.06.06-.15.1-.23.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2292-2"
                d="m320.85,177.3c-.18,0-.33-.15-.33-.33,0-.09.03-.17.1-.23l1.05-1.05c.13-.13.34-.13.47,0s.13.34,0,.47l-1.05,1.05c-.06.06-.15.1-.23.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2293-2"
                d="m318.78,183.54c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76,3.76,1.68,3.76,3.76-1.68,3.76-3.76,3.76m0-6.86c-1.71,0-3.1,1.39-3.1,3.1s1.39,3.1,3.1,3.1,3.1-1.39,3.1-3.1h0c0-1.71-1.39-3.1-3.1-3.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2294-2"
                d="m318.78,180.52c-.41,0-.74-.33-.74-.74s.33-.74.74-.74.74.33.74.74-.33.74-.74.74m0-.82s-.08.04-.08.08c0,.09.16.09.16,0,0-.04-.03-.08-.08-.08h0"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2295-2"
                d="m318.78,183.54c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76,3.76,1.68,3.76,3.76-1.68,3.76-3.76,3.76m0-6.86c-1.71,0-3.1,1.39-3.1,3.1s1.39,3.1,3.1,3.1,3.1-1.39,3.1-3.1h0c0-1.71-1.39-3.1-3.1-3.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2296-2"
                d="m318.78,177.73c-.18,0-.33-.15-.33-.33v-.43c0-.18.15-.33.33-.33s.33.15.33.33v.43c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2297-2"
                d="m318.78,182.88c-.18,0-.33-.15-.33-.33v-.43c0-.18.15-.33.33-.33s.33.15.33.33v.43c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2298-2"
                d="m321.56,180.09h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2299-2"
                d="m316.42,180.09h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <text
                transform="translate(330.95 182.3)"
                fill="#405184"
                font-family="SourceSansPro-BoldItalic, 'Source Sans Pro'"
                font-size="8"
                font-style="italic"
                font-weight="700"
                letter-spacing="-.01em">
                <tspan
                    x="0"
                    y="0">
                    Automation Signal
                </tspan>
            </text>
            <text
                transform="translate(177.35 162.44)"
                fill="#555"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="6"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Sends Data
                </tspan>
            </text>
            <path
                id="Path_1358"
                d="m149.13,147.6c0-1.08.87-1.96,1.95-1.96h2.81c1.08,0,1.96.88,1.96,1.96s-.88,1.96-1.96,1.96h-2.81c-1.08,0-1.95-.88-1.95-1.96"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1359"
                d="m166.7,147.57v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1360"
                d="m175.73,147.57v.06c0,1.06-.87,1.92-1.93,1.92-1.06,0-1.92-.86-1.92-1.92v-.06c0-1.06.87-1.92,1.93-1.92,1.06,0,1.92.86,1.92,1.92"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1351"
                d="m308.2,157.61l8.74-8.62h0s.06-.06.09-.1l.04-.04c.21-.25.35-.54.41-.86h0c.01-.06.02-.12.03-.19s.01-.13.01-.19c0-.07,0-.13-.01-.19,0-.06-.02-.12-.03-.19h0c-.06-.32-.2-.61-.41-.86-.01-.02-.03-.03-.04-.04-.03-.03-.06-.07-.09-.1h0l-8.74-8.62c-.8-.72-2.04-.66-2.76.15-.67.75-.67,1.89.01,2.63l5.35,5.28h-14.35c-1.08,0-1.96.88-1.96,1.96s.88,1.96,1.96,1.96h14.35l-5.35,5.28c-.79.74-.82,1.98-.08,2.76s1.98.82,2.76.08c.02-.02.05-.04.07-.07"
                fill="#44b649"
                stroke-width="0" />
            <g id="Group_501">
                <path
                    id="Path_1295"
                    d="m272.59,147.4v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                    fill="#44b649"
                    stroke-width="0" />
            </g>
            <path
                id="Path_1296"
                d="m261.85,147.4v-.06c0-1.06.87-1.92,1.93-1.92,1.06,0,1.92.86,1.92,1.92v.06c0,1.06-.87,1.92-1.93,1.92-1.06,0-1.92-.86-1.92-1.92"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1297"
                d="m251.1,147.4v-.06c0-1.06.87-1.92,1.93-1.92,1.06,0,1.92.86,1.92,1.92v.06c0,1.06-.87,1.92-1.93,1.92-1.06,0-1.92-.86-1.92-1.92"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1298"
                d="m240.35,147.4v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1298-2"
                d="m228.76,147.78v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1298-3"
                d="m217.05,147.78v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1298-4"
                d="m203.92,147.78v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1303"
                d="m196.72,142.9c.38-.17.74-.38,1.08-.62v1.55c0,.34-.25.78-.9,1.2.71-.04,1.42.06,2.09.3v-5.06c0-1.2-1.04-2.09-2.27-2.64-3.13-1.23-6.61-1.23-9.74,0-1.22.56-2.26,1.45-2.26,2.64v10.71c0,1.2,1.04,2.09,2.26,2.64,1.54.64,3.2.95,4.87.92.62,0,1.24-.04,1.85-.11-.37-.32-.7-.69-.97-1.1-.29.02-.58.03-.88.03-1.5.03-2.99-.25-4.38-.82-1.14-.52-1.57-1.12-1.57-1.56v-1.56c.33.25.69.46,1.07.62,1.54.64,3.2.95,4.87.92h.03c-.04-.4-.04-.79,0-1.19h-.03c-1.5.03-2.99-.25-4.38-.82-1.14-.52-1.57-1.12-1.57-1.56v-1.55c.33.25.69.46,1.07.62,1.54.64,3.2.95,4.87.92.31,0,.62-.01.92-.03.35-.52.8-.98,1.31-1.35-.74.13-1.48.19-2.23.19-1.5.03-2.99-.25-4.38-.82-1.14-.52-1.57-1.12-1.57-1.56v-1.55c.33.25.69.46,1.07.62,3.13,1.23,6.61,1.23,9.74,0m-10.81-2.64c0-.44.42-1.04,1.57-1.56,2.82-1.09,5.94-1.09,8.76,0,1.14.52,1.57,1.12,1.57,1.56s-.43,1.04-1.57,1.56c-2.82,1.09-5.94,1.09-8.76,0-1.14-.52-1.57-1.12-1.57-1.56"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1304"
                d="m200.82,149.63l-.18-.05c-.05-.01-.1-.04-.15-.06-.37-.2-.5-.66-.3-1.03l.09-.16c.2-.37.06-.83-.31-1.03-.23-.12-.5-.12-.73,0l-.16.09s-.1.05-.15.06c-.4.12-.83-.11-.95-.52l-.05-.18c-.12-.4-.54-.63-.95-.52-.25.07-.44.27-.52.52l-.05.18c-.02.05-.04.1-.06.15-.2.37-.66.51-1.03.31,0,0,0,0,0,0l-.16-.09c-.37-.2-.83-.06-1.03.31-.12.23-.12.5,0,.73l.09.16s.05.1.06.15c.12.4-.11.82-.51.94,0,0,0,0,0,0l-.18.05c-.4.12-.63.54-.52.95.07.25.27.44.52.52l.18.05c.05.01.1.04.15.06.37.2.5.66.3,1.03l-.09.16c-.2.37-.06.83.31,1.03.23.12.5.12.73,0l.16-.09s.1-.05.15-.06c.4-.12.83.11.95.51l.05.18c.12.4.54.63.95.52.25-.07.44-.27.52-.52l.05-.18c.02-.05.04-.1.06-.15.2-.37.66-.51,1.03-.31,0,0,0,0,0,0l.16.09c.37.2.83.06,1.03-.31.12-.23.12-.5,0-.73l-.09-.16s-.05-.1-.06-.15c-.12-.4.11-.83.51-.94h0s.18-.05.18-.05c.4-.12.63-.54.52-.95-.07-.25-.27-.44-.52-.52m-3.62,2.51c-.99,0-1.78-.8-1.78-1.78s.8-1.78,1.78-1.78,1.78.8,1.78,1.78h0c0,.99-.8,1.78-1.78,1.78"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1352"
                d="m282.51,147.6c0-1.08.88-1.95,1.95-1.96h2.81c1.08,0,1.96.88,1.96,1.96s-.88,1.96-1.96,1.96h-2.81c-1.08,0-1.95-.88-1.95-1.96"
                fill="#44b649"
                stroke-width="0" />
            <text
                transform="translate(235.9 191.14)"
                fill="#555"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="6"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Sends Signal
                </tspan>
            </text>
            <path
                id="Path_1291"
                d="m142.07,166.32l-8.74,8.62h0s-.06.06-.09.1l-.04.04c-.21.25-.35.54-.41.86h0c-.01.06-.02.12-.03.19s-.01.13-.01.2c0,.07,0,.13.01.2,0,.06.02.12.03.19h0c.06.32.2.61.41.86.01.02.03.03.04.04.03.03.06.07.09.1h0l8.74,8.62c.77.76,2.01.75,2.77-.02.76-.77.75-2.01-.02-2.76l-5.35-5.28h14.35c1.08,0,1.96-.88,1.96-1.96s-.88-1.96-1.96-1.96h-14.35l5.35-5.28c.79-.74.82-1.98.08-2.76-.74-.79-1.98-.82-2.76-.08-.02.02-.05.04-.07.07"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1292"
                d="m167.75,176.45c0,1.08-.88,1.95-1.95,1.96h-2.81c-1.08,0-1.95-.88-1.95-1.96s.88-1.96,1.95-1.96h2.81c1.08,0,1.95.88,1.95,1.96"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1293"
                d="m298.88,176.45c0,1.08-.88,1.95-1.96,1.96h-2.81c-1.08,0-1.96-.88-1.96-1.96s.88-1.96,1.96-1.96h2.81c1.08,0,1.95.88,1.96,1.96"
                fill="#44b649"
                stroke-width="0" />
            <g id="Path_1200">
                <path
                    d="m258.91,182.96c-.1,0-.19-.04-.26-.11-.15-.15-.15-.38,0-.53,3.46-3.46,3.46-9.1,0-12.56-.15-.15-.15-.38,0-.53.15-.15.38-.15.53,0,3.75,3.76,3.75,9.87,0,13.62-.07.07-.17.11-.27.11Z"
                    fill="#555"
                    stroke-width="0" />
            </g>
            <g id="Path_1201">
                <path
                    d="m257.2,181.25c-.1,0-.19-.04-.26-.11-.15-.15-.15-.38,0-.53,2.52-2.52,2.52-6.63,0-9.15-.15-.15-.15-.38,0-.53.15-.15.38-.15.53,0,2.81,2.81,2.81,7.39,0,10.21-.07.07-.17.11-.27.11Z"
                    fill="#555"
                    stroke-width="0" />
            </g>
            <g id="Path_1202">
                <path
                    d="m255.5,179.54c-.1,0-.19-.04-.26-.11-.15-.15-.15-.38,0-.53,1.58-1.58,1.58-4.15,0-5.73-.15-.15-.15-.38,0-.53.15-.15.38-.15.53,0,1.87,1.87,1.87,4.92,0,6.79-.07.07-.17.11-.27.11Z"
                    fill="#555"
                    stroke-width="0" />
            </g>
            <g id="Path_1203">
                <path
                    d="m245.53,182.96c-.1,0-.19-.04-.27-.11-3.75-3.76-3.75-9.87,0-13.62.15-.15.38-.15.53,0,.15.15.15.38,0,.53-3.46,3.46-3.46,9.1,0,12.56.15.15.15.38,0,.53-.07.07-.17.11-.26.11Z"
                    fill="#555"
                    stroke-width="0" />
            </g>
            <g id="Path_1204">
                <path
                    d="m247.23,181.25c-.1,0-.19-.04-.27-.11-2.81-2.81-2.81-7.39,0-10.21.15-.15.38-.15.53,0,.15.15.15.38,0,.53-2.52,2.52-2.52,6.63,0,9.15.15.15.15.38,0,.53-.07.07-.17.11-.26.11Z"
                    fill="#555"
                    stroke-width="0" />
            </g>
            <g id="Path_1205">
                <path
                    d="m248.94,179.54c-.1,0-.19-.04-.27-.11-1.87-1.87-1.87-4.92,0-6.79.15-.15.38-.15.53,0,.15.15.15.38,0,.53-1.58,1.58-1.58,4.15,0,5.73.15.15.15.38,0,.53-.07.07-.17.11-.26.11Z"
                    fill="#555"
                    stroke-width="0" />
            </g>
            <g id="Ellipse_4">
                <path
                    d="m252.22,177.95c-1.05,0-1.91-.86-1.91-1.91s.86-1.91,1.91-1.91,1.91.86,1.91,1.91-.86,1.91-1.91,1.91Zm0-3.08c-.64,0-1.16.52-1.16,1.16s.52,1.16,1.16,1.16,1.16-.52,1.16-1.16-.52-1.16-1.16-1.16Z"
                    fill="#555"
                    stroke-width="0" />
            </g>
            <g id="Group_495">
                <path
                    id="Path_1294"
                    d="m174.36,176.48v-.06c0-1.06.87-1.92,1.93-1.92,1.06,0,1.92.86,1.92,1.92v.06c0,1.06-.87,1.92-1.93,1.92-1.06,0-1.92-.86-1.92-1.92"
                    fill="#44b649"
                    stroke-width="0" />
            </g>
            <g id="Group_553">
                <path
                    id="Path_1354"
                    d="m217.05,176.59v-.06c0-1.06.87-1.92,1.93-1.92,1.06,0,1.92.86,1.92,1.92v.06c0,1.06-.87,1.92-1.93,1.92-1.06,0-1.92-.86-1.92-1.92"
                    fill="#44b649"
                    stroke-width="0" />
            </g>
            <g id="Group_553-2">
                <path
                    id="Path_1354-2"
                    d="m228.09,176.48v-.06c0-1.06.87-1.92,1.93-1.92,1.06,0,1.92.86,1.92,1.92v.06c0,1.06-.87,1.92-1.93,1.92-1.06,0-1.92-.86-1.92-1.92"
                    fill="#44b649"
                    stroke-width="0" />
            </g>
            <g id="Group_553-3">
                <path
                    id="Path_1354-3"
                    d="m267.75,176.48v-.06c0-1.06.87-1.92,1.93-1.92,1.06,0,1.92.86,1.92,1.92v.06c0,1.06-.87,1.92-1.93,1.92-1.06,0-1.92-.86-1.92-1.92"
                    fill="#44b649"
                    stroke-width="0" />
            </g>
            <g id="Group_553-4">
                <path
                    id="Path_1354-4"
                    d="m280.58,176.48v-.06c0-1.06.87-1.92,1.93-1.92,1.06,0,1.92.86,1.92,1.92v.06c0,1.06-.87,1.92-1.93,1.92-1.06,0-1.92-.86-1.92-1.92"
                    fill="#44b649"
                    stroke-width="0" />
            </g>
            <g id="Group_559">
                <path
                    id="Path_1355"
                    d="m206.31,176.48v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                    fill="#44b649"
                    stroke-width="0" />
            </g>
            <g id="Group_565">
                <path
                    id="Path_1356"
                    d="m195.56,176.48v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                    fill="#44b649"
                    stroke-width="0" />
            </g>
            <g id="Group_571">
                <path
                    id="Path_1357"
                    d="m184.82,176.48v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                    fill="#44b649"
                    stroke-width="0" />
            </g>
        </g>
    </svg>
</template>
